export default {
    todaySales: state => state.todaySales,
    lastSalesByDay: state => state.lastSalesByDay,
    balance: state => state.balance,
    tablesLength: state => {
        return { transactionsLength: state.transactionsLength, billsToPayLength: state.billsToPayLength, billsToRecieveLength: state.billsToRecieveLength}
      },
}